<template>
  <div>
    <MapModal
      class="newModelPosition"
      :modalNode="modalNode"
      :submitData="submitData"
      :submit="submit"
      :close="close"
      :title="simulationTitle"
      id="fixedRouteAddSpot"
    >
    </MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");

//按需加载
import { addBimTrafficSimulationContent } from "@/api/api";
import * as mapWork from "./trafficSimulation.js";
import _ from "lodash";
export default {
  name: "fixed-route-add-spot",
  components: { MapModal },
  props: ["close", "addSpotId", "currentState"],
  data() {
    return {
      show: false,
      data: [],
      simulationTitle: "新增点",
      modalNode: {
        fixedRouteAddSpot: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -750,
          },

          height: "auto", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // // 模态框中心配置
          content: {
            type: "form",
            formData: {
              position: {
                md: 24,
                type: "button",
                title: "添加标点",
                buttonTitle: "选点",
                disabled: false,
                click: this.add,
                show: true,
              },
            },
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
      submitData: {
        position: [],
      },
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    add() {
      let text = ""; // 点的名称
      // this.modalNode.fixedRouteAddSpot.content.formData.position
      mapWork.addPathPoint(
        text,
        (e) => {
          // 获取点集合
          let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
            e.graphic._position_draw
          );
          // 初始化数据
          if (mapWork.routePointSet.length == 0) {
            mapWork.routePointSet.push([]);
          }
          //把点集合存入 routePointSet
          mapWork.routePointSet[0].push([_lng, _lat, _alt]);
          // 绘制线
          mapWork.drawLine(mapWork.routePointSet[0]);
          this.modalNode.fixedRouteAddSpot.content.formData.position.disabled = true;
          this.submitData.position = [_lng, _lat, _alt];
        },
        (e) => {
          let { _alt, _lat, _lng } = mars3d.LngLatPoint.fromCartesian(
            e.graphic._position_draw
          );
          mapWork.routePointSet[0][mapWork.routePointSet[0].length - 1] = [
            _lng,
            _lat,
            _alt,
          ];
          mapWork.drawLine(mapWork.routePointSet[0]);
          this.submitData.position = [_lng, _lat, _alt];
        }
      );
    },
    submit() {
      if (this.submitData.position.length > 0) {
        console.log(mapWork.routePointSet[0].length);
        let data = {
          pId: this.addSpotId,
          projectId: this.projectId,
          name: mapWork.routePointSet[0].length.toString(),
          contentValue: `${this.submitData.position.toString()}`,
        };

        addBimTrafficSimulationContent(data)
          .then((res) => {
            // this.$emit("refresh");
            let { code } = res.data;
            if (code == 200 || code == 204) {
              this.close();
              this.$emit("refresh");
              this.$notify({
                title: "保存成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            } else {
              this.$notify({
                title: "保存失败",
                message: "",
                type: "error",
                duration: 960,
                offset: 320,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            this.$notify({
              title: "保存失败",
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
          });
      } else {
        this.$message({
          message: "请新增点",
          type: "error",
          offset: 100,
          showClose: true,
          duration: 1600,
        });
      }
    },
  },
  mounted() {},
  destroyed() {
    mapWork.init();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.el-scrollbar__bar.is-vertical {
  width: 6px;
  top: 2px;
}
.el-scrollbar__bar {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 120ms ease-out;
}
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: initial;
  min-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  // max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
</style>
